import React from 'react';
import styled from 'styled-components';

import { FormGroup, FormRadio } from '@spotify-internal/encore-creator-web';

import { DialogBodyProps } from '../../types';

const Span16 = styled.span`
  font-size: 16px;
  line-height: 24px;
`;

const options = {
  fundraisinglink: { type: 'input', displayName: 'Fundraising link' },
  musicrelieforg: {
    type: 'select',
    displayName: 'Music Relief organization',
  },
} as const;

export function RadioGroup(
  props: DialogBodyProps & {
    isFundraisingLinkSelected: boolean;
    setIsFundraisingLinkSelected: (isSelected: boolean) => void;
  },
) {
  function onProviderChange(ev: React.ChangeEvent<HTMLInputElement>) {
    const nextProvider = ev.target.value;
    if (nextProvider === 'musicrelieforg') {
      props.link.reset();
      props.org.reset();
      props.provider.setValue(ev);
      props.setIsFundraisingLinkSelected(false);
    } else {
      props.link.reset();
      props.org.reset();
      props.provider.reset();
      props.setIsFundraisingLinkSelected(true);
    }
  }

  const radioGroupAriaLabel = props.isEditing
    ? 'Edit your Artist Fundraising Pick'
    : 'Set your Artist Fundraising Pick';

  function getChecked(
    key: keyof typeof options,
    providerValue: typeof props.provider.value,
  ) {
    return (
      // TODO This is unfortunate, maybe refactor
      (key === providerValue && !props.isFundraisingLinkSelected) ||
      (key === 'fundraisinglink' && props.isFundraisingLinkSelected)
    );
  }

  return (
    <FormGroup role="radiogroup" aria-label={radioGroupAriaLabel}>
      {Object.entries(options).map(([key, option]) => {
        const formRadioId = `fundraising-pick-type-${key}`;

        const isChecked = getChecked(
          key as keyof typeof options,
          props.provider.value,
        );

        return (
          <React.Fragment key={key}>
            <FormRadio
              aria-checked={isChecked}
              checked={isChecked}
              id={formRadioId}
              name="fundraising-pick-type"
              onChange={onProviderChange}
              value={key}
            >
              <Span16>{option.displayName}</Span16>
            </FormRadio>
          </React.Fragment>
        );
      })}
    </FormGroup>
  );
}
